/*
 * fn: initializeGA
 *
 * Initializes Google Analytics
 *
 */
import ReactGA from 'react-ga4'

import { IS_ANALYTICS_ENABLED } from '@/defs/analytics'

export const initializeGA = () => {
  if (!IS_ANALYTICS_ENABLED) return

  const measurementId = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID
  if (!measurementId) return

  ReactGA.initialize(measurementId, {
    gaOptions: {
      // Wait to send initial pageview until auth is loaded
      send_page_view: false,
    },
  })
}
